import React, { useCallback } from 'react';
import { updateLogo } from 'actions/livefeed'
import { Rnd } from 'react-rnd';
import { RndStyle } from './RndStyle'
import update from 'immutability-helper';
import * as a from 'actions/livefeedapi';
import { getPosition, handleSetCurrentEntity } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import { useHover } from 'components/common/hooks'
/*
Special rule for using react-rnd
If the entity has padding and border: for example padding 5, border 1
then onDragStop or onResizeStop will return x,y and width include padding + border
So,if the padding and border for are added for editor view only,
the actual value need to be calculated. ( minos 6 for x,y and minos 12 for width)
But the position value props and size set on react-rnd component need to plus 6 for x,y and 12 for width from state,.
*/
const LogoContainer = ({ editorView, scaleMode, dispatch, stepNumberState, slideCurrentIndex, livefeedSlides }) => {
    const { logoState, historyEntities } = livefeedSlides[slideCurrentIndex];
    let history = historyEntities.slice();
    let currentEntity = history[stepNumberState];


    const isLogoUploaded = logoState.url ? true : false;
    const enableResizing = {
        bottom: isLogoUploaded, bottomLeft: isLogoUploaded, bottomRight: isLogoUploaded,
        left: isLogoUploaded, right: isLogoUploaded, top: isLogoUploaded,
        topLeft: isLogoUploaded, topRight: isLogoUploaded
    }

    const setLogoPos = useCallback((newPosition) => {
        let { x, y } = newPosition;
        // prevent duplicate dispatch
        if (logoState.left !== x || logoState.top !== y) {
            const newLogoState = update(logoState, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: "" },
                activeToolbarItems: { [0]: { align: { $set: "" } } }
            });
            dispatch(updateLogo(newLogoState));
        }
    }, [dispatch, logoState])

    const setLogoSize = useCallback((width, newPosition) => {
        let newWidth = width > 534 ? 534 : width; // maximum width 534
        let { x, y } = newPosition
        let align = `${logoState.left === x ? `${logoState.activeToolbarItems[0].align}` : ""}` // if x doesn't change, keep toolbar active
        if (logoState.width !== width || logoState.left !== newPosition.x) {
            const newLogoState = update(logoState, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: align },
                width: { $set: newWidth },
                activeToolbarItems: {
                    [0]: {
                        align: { $set: align }
                    }
                }
            });
            dispatch(updateLogo(newLogoState));
        }
    }, [dispatch, logoState])

    const logoUploadHandler = useCallback((e) => {
        var reader = new FileReader();
        var file = e.target.files[0];
        reader.onloadend = () => {
            dispatch(a.uploadLogo(file))
        }
        file && reader.readAsDataURL(file);
    }, [dispatch])
    const handleSetCurrentEntityCallback = useCallback(() => {
        handleSetCurrentEntity(currentEntity, logoState, dispatch)
    }, [currentEntity, dispatch, logoState])

    const [logoHoverRef, isLogoHovered] = useHover();
    const fixZindexIssue = isLogoHovered ? { zIndex: 3 } : {}
    return (
        <React.Fragment>
            {logoState.show && (
                editorView ?
                    <Rnd
                        bounds={".livefeed-preview-wrapper"}
                        data-tooltip={`${!isLogoUploaded ? 'Click upload icon to upload \n Recommended file type: PNG\n To delete Logo Placeholder, simply click the text then click Delete icon on the toolbar ' : `Click on the corner and drag to resize \n Click and drag to the desired position\n Current width ${logoState.width}px`}`}
                        style={{
                            padding: isLogoUploaded ? '5px' : 0,
                            ...fixZindexIssue
                        }}
                        enableResizing={enableResizing}
                        disableDragging={!isLogoUploaded}
                        className={`entity-resizable ${isLogoUploaded ? '' : 'logo-resizable_bg'} ${currentEntity.id === 'logo' ? 'entity-active' : ''} `}
                        lockAspectRatio={true}
                        resizeHandleWrapperClass={"resizers"}
                        resizeHandleStyles={{
                            topRight: RndStyle.topRight, topLeft: RndStyle.topLeft,
                            bottomLeft: RndStyle.bottomLeft, bottomRight: RndStyle.bottomRight
                        }}
                        // Size width need to plus 12 due to padding 5 and border 1
                        size={{ width: logoState.url ? (logoState.width * (scaleMode ? 0.375 : 1) + 12) : (180 * (scaleMode ? 0.375 : 1)), height: "auto" }}
                        position={{ x: logoState.left * (scaleMode ? 0.375 : 1) - 6, y: logoState.top * (scaleMode ? 0.375 : 1) - 6 }}// minus padding+border
                        onClick={() => handleSetCurrentEntityCallback()}
                        onDragStart={() => handleSetCurrentEntityCallback()}
                        onDragStop={(e, d) => setLogoPos(getPosition(d))}
                        onResizeStart={() => handleSetCurrentEntityCallback()}
                        onResizeStop={(e, direction, ref, delta, position) =>
                            position.x !== 0 && setLogoSize(ref.offsetWidth - 12, getPosition(position))}
                    >
                        <div ref={logoHoverRef} className={`logo-wrapper ${!isLogoUploaded && "upload-btn"}`} >
                            {isLogoUploaded ?
                                <img alt="Logo Placeholder" id={logoState.id} draggable="false" src={logoState.url} />
                                :
                                <React.Fragment>
                                    <input id="logo" type="file" onChange={(e) => logoUploadHandler(e)} />
                                    <span>Logo Placeholder</span> <label htmlFor="logo"><i className="material-icons">backup</i></label>
                                </React.Fragment>
                            }
                        </div>
                    </Rnd>
                    :
                    <div
                        style={{
                            padding: logoState.url ? 5 : 0,
                            position: "absolute",
                            width: logoState.url ? (logoState.width * (scaleMode ? 0.375 : 1) + 12) : (180 * (scaleMode ? 0.375 : 1)),
                            height: "auto",
                            pointerEvents: "none",
                            left: logoState.left * (scaleMode ? 0.375 : 1) - 6,
                            top: logoState.top * (scaleMode ? 0.375 : 1) - 6
                        }}
                        className={`entity-resizable ${isLogoUploaded ? '' : 'logo-resizable_bg'} editor-view_false`}
                    >
                        <div className={`logo-wrapper ${!isLogoUploaded && "upload-btn"}`} >
                            {isLogoUploaded ?
                                <img id={logoState.id} draggable="false" src={logoState.url} />
                                :
                                <React.Fragment>
                                    <input id="logo" disabled={true} type="file" readOnly />
                                    <span>Logo Placeholder</span> <i className="material-icons">backup</i>
                                </React.Fragment>
                            }
                        </div>
                    </div>
            )
            }
        </React.Fragment>
    );
}
export default LogoContainer;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/LogoContainer.jsx